import { useEffect, useRef } from 'react'
import { trackError } from '@vend/utilities'
import { $stateParams } from '../../../../ng-compat/imports'
import { LSPaymentProps } from './useTransactionRecovery'

/**
 * Hook to handle lspay quick pay on payment page
 * Run once only when lspayPaymentType is set
 */
export const useLSPayQuickPay = (props: LSPaymentProps) => {
  const { lspayPaymentType, pay } = props
  const ref = useRef(false)

  useEffect(() => {
    if (ref.current || !lspayPaymentType) {
      return
    }

    try {
      if ($stateParams.lspayQuickPaySelected) {
        pay(lspayPaymentType)
      }
    } catch (error) {
      trackError('Failed to complete a quick pay transaction with LSPay', {
        error,
      })
    } finally {
      ref.current = true
    }
  }, [lspayPaymentType, pay])
}
